var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as _ from 'lodash';
import keyboardKey from 'keyboard-key';
import { customPropTypes, createShorthandFactory, UIComponent, commonPropTypes, } from '../../lib';
import { Image, Icon, Label } from '../..';
/**
 * A DropdownLabel is a sub-component of a multiple selection Dropdown.
 * It is used to display selected item.
 */
var DropdownLabel = /** @class */ (function (_super) {
    __extends(DropdownLabel, _super);
    function DropdownLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'DropdownLabel';
        _this.className = 'ui-dropdown__label';
        _this.handleClick = function (e) {
            _.invoke(_this.props, 'onClick', e, _this.props);
        };
        _this.handleIconOverrides = function (predefinedProps) { return ({
            onClick: function (e, iconProps) {
                e.stopPropagation();
                _.invoke(_this.props, 'onRemove', e, _this.props);
                _.invoke(predefinedProps, 'onClick', e, iconProps);
            },
            onKeyDown: function (e, iconProps) {
                e.stopPropagation();
                if (keyboardKey.getCode(e) === keyboardKey.Enter) {
                    _.invoke(_this.props, 'onRemove', e, _this.props);
                }
                _.invoke(predefinedProps, 'onKeyDown', e, iconProps);
            },
        }); };
        return _this;
    }
    DropdownLabel.prototype.renderComponent = function (_a) {
        var rest = _a.rest, styles = _a.styles;
        var _b = this.props, header = _b.header, icon = _b.icon, image = _b.image;
        return (React.createElement(Label, __assign({ styles: styles.root, role: "presentation", circular: true, onClick: this.handleClick, content: header, icon: Icon.create(icon, {
                defaultProps: {
                    'aria-label': "Remove " + header + " from selection.",
                    'aria-hidden': false,
                    role: 'button',
                },
                overrideProps: this.handleIconOverrides,
            }), image: Image.create(image, {
                defaultProps: {
                    avatar: true,
                },
            }) }, rest)));
    };
    DropdownLabel.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
    }), { header: PropTypes.string, icon: customPropTypes.itemShorthand, image: customPropTypes.itemShorthand, onClick: PropTypes.func, onRemove: PropTypes.func });
    DropdownLabel.defaultProps = {
        icon: 'close',
    };
    return DropdownLabel;
}(UIComponent));
DropdownLabel.create = createShorthandFactory(DropdownLabel, 'header');
export default DropdownLabel;
